import React from 'react';
import healthIcon from '../assets/images/objectives/health.svg';
import fintechIcon from '../assets/images/objectives/fintech.svg';
import ecomIcon from '../assets/images/objectives/ecom.svg';
import iaIcon from '../assets/images/objectives/ia.svg';
import agroIcon from '../assets/images/objectives/agro.svg';
import logisticIcon from '../assets/images/objectives/logistic.svg';

const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId);
  if (section) {
    section.scrollIntoView({ behavior: 'smooth' });
  }
};

const SectorIcon = ({ icon: Icon, label }) => (
  <div className="text-center">
    <div className="lg:h-40 xl:h-48 mx-auto mb-4">
      {Icon}
    </div>
    <span className="bottom-4 text-white text-xl lg:text-2xl capitalize font-semibold text-center">{label}</span>
  </div>
);

const ObjectiveSection = ({ id }) => {
  const sectors = [
    {
      icon: <img src={healthIcon} alt="Ícone do setor de saúde" className="h-24 lg:h-40 xl:h-48 mx-auto" />,
      label: 'saúde'
    },
    {
      icon: <img src={fintechIcon} alt="Ícone do setor fintech" className="h-24 lg:h-40 xl:h-48 mx-auto" />,
      label: 'fintech'
    },
    {
      icon: <img src={ecomIcon} alt="Ícone do setor de e-commerce" className="h-24 lg:h-40 xl:h-48 mx-auto" />,
      label: 'e-commerce'
    },
    {
      icon: <img src={iaIcon} alt="Ícone do setor de IA" className="h-24 lg:h-40 xl:h-48 mx-auto" />,
      label: 'IA'
    },
    {
      icon: <img src={agroIcon} alt="Ícone do setor de agro" className="h-24 lg:h-40 xl:h-48 mx-auto" />,
      label: 'agro'
    },
    {
      icon: <img src={logisticIcon} alt="Ícone do setor de logística" className="h-24 lg:h-40 xl:h-48 mx-auto" />,
      label: 'logística'
    }
  ];

  return (
    <section className="bg-[#151342] py-12 lg:py-32 px-4" id={id}>
      <div className="max-w-[1920px] mx-auto text-center">
        <h2 className="mb-8">
          <span className="text-white text-4xl lg:text-5xl font-['ZenDots'] block">Nosso objetivo é fazer o seu</span>
          <span className="text-[#C6FF00] text-4xl lg:text-5xl font-['ZenDots']">NEGÓCIO CRESCER</span>
        </h2>
        
        <p className="text-white text-xl mb-12 lg:text-2xl max-w-6xl mx-auto w-full text-center">
          Atuamos como braço tecnológico, ajudando empresas de diversos setores
          a estruturar suas soluções desde o desenvolvimento à evolução contínua.
        </p>

        <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 sm:w-[80%] sm:mx-auto lg:gap-12 mb-12">
          {sectors.map((sector, index) => (
            <SectorIcon key={index} {...sector} />
          ))}
        </div>
        <a
          href="/forms"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button onClick={() => scrollToSection('contact')} className="bg-[#C6FF00] text-[#151342] mb-4 px-8 py-4 lg:px-12 lg:py-6 rounded-full text-xl lg:text-2xl font-semibold hover:bg-[#151342] hover:text-[#C6FF00] border-2 border-[#C6FF00] transition-colors duration-300 hover:scale-105 animate-pulse-border">
            Contratar a BianCode
          </button>
        </a>
      </div>
    </section>
  );
};

export default ObjectiveSection;
